import { cn } from '@/lib/utils'
import { type TourContentProps, tourContentVariants } from './tour-variants'

export function TourContent({ children, intent, className }: TourContentProps) {
  return <div className={cn(tourContentVariants({ intent }), className)}>{children}</div>
}
